// Portfolio Page - Complete Image Data (synced from production)

export const portfolioData = {
  "mainShots": [
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/tbpy2ma2_DSCF0315.jpg",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/ehia6frw_IMG_6801.JPG",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/djx7i2hy_IMG_5995.JPG"
  ],
  "profiles": [
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/kglwtzkb_IMG_6774.JPG",
    "/api/portfolio/image/komal-portfolio/portfolio/89b5f3286c264629bac0216db9dafd08.jpg",
    "/api/portfolio/image/komal-portfolio/portfolio/9054d78cde0b4720a9e20d3c89a288ac.jpg"
  ],
  "shoots": [
    {
      "title": "Between the Lines",
      "subtitle": "Indoor \u00b7 Soft Light \u00b7 Reverie",
      "heroIndex": 3,
      "images": [
        "/images/shoot1_1825.jpg",
        "/images/shoot1_1851.jpg",
        "/images/shoot1_1869.jpg",
        "/images/shoot1_1890.jpg",
        "/images/shoot1_1928.jpg",
        "/images/shoot1_1942.jpg",
        "/images/shoot1_2015.jpg",
        "/images/shoot1_2035.jpg",
        "/images/shoot1_2087.jpg",
        "/images/shoot1_2099.jpg"
      ]
    },
    {
      "title": "Rooted in Grace",
      "subtitle": "Memory \u00b7 Feminine \u00b7 Timeless    ",
      "heroIndex": 0,
      "images": [
        "/api/portfolio/image/komal-portfolio/portfolio/8f76a63e3cc44a3db403e0a71b150fa8.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/uk5k96pv_B1CCC00C-6EB7-4D67-BE6F-E8015233E919.png",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/ymm5n7ps_323ED9A8-EFEF-455C-88BB-6A925606C77C.png",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/bg5dqe01_IMG_37A7A9E3-FD54-4BCB-816C-06D92797850F.jpeg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/ov910245_IMG_489F7DB1-46EB-47C6-9E5D-164F76ED32A0.jpeg",
        "/api/portfolio/image/komal-portfolio/portfolio/6f8c51e71aa348bd9b60d5137557d69f.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/tdmic88p_IMG_E63917C4-B810-4893-AA03-47917171D6D1.jpeg"
      ]
    },
    {
      "title": "After Hours",
      "subtitle": "Bold \u00b7 Electric \u00b7 Untamed",
      "heroIndex": 11,
      "images": [
        "/images/shoot5_04DA.jpg",
        "/images/shoot5_5A99.jpg",
        "/images/shoot5_7B88.jpg",
        "/images/shoot5_8A3D.jpg",
        "/images/shoot5_8ECA.jpg",
        "/images/shoot5_88CA.jpg",
        "/images/shoot5_610E.jpg",
        "/images/shoot5_3170.jpg",
        "/images/shoot5_8535.jpg",
        "/images/shoot5_A1E3.jpg",
        "/images/shoot5_BF52.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/knn5352p_DSCF0236.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/4tkmo8jr_DSCF0297.jpg"
      ]
    },
    {
      "title": "Light & Shadow",
      "subtitle": "Monochrome \u00b7 Dramatic \u00b7 Becoming",
      "heroIndex": 3,
      "images": [
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/wvqv8a59_DSCF0221.jpg",
        "/api/portfolio/image/komal-portfolio/portfolio/54e921d74cb0477fa039d5486353d067.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/p8d3mstw_IMG_6616.JPG",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/j7nva1kf_IMG_6667.JPG",
        "/api/portfolio/image/komal-portfolio/portfolio/43df68c2c7d64a3f80e69272e886e574.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/hdtmxc9n_IMG_6872.JPG",
        "/images/portfolio/3ee5b9cf483748ab844b6b10f888461d.jpg"
      ]
    },
    {
      "title": "Off Script",
      "subtitle": "Fun \u00b7 Playful \u00b7 Unfiltered",
      "heroIndex": 5,
      "images": [
        "/images/shoot4_2066.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/l9224b8o_IMG_6681.JPG",
        "/images/shoot4_2080.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/thg35g2i_IMG_6703.JPG",
        "/images/shoot4_2109.jpg",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/stck61vh_IMG_6721.JPG",
        "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/uww4x8be_IMG_6774.JPG"
      ]
    }
  ],
  "statement": [
    "/images/shoot6_43FD.jpg",
    "/images/shoot6_A7CA.jpg",
    "/images/shoot6_C838.jpg"
  ],
  "skyHigh": {
    "heroIndex": 0,
    "images": [
      "/images/portfolio/a4f354dc970e4ae3abf7e70735b0883f.jpg",
      "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/lkhbgb4e_66134E74-F33C-4945-8566-CF2EEDECC028.png",
      "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/jkum4m69_EB9CA2BA-F7C5-4574-A049-8D18494D5DD9.png",
      "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/svst60f9_IMG_5558.jpg"
    ]
  },
  "movieFrames": [
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/4w307fce_DDLJ.png",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/zw3cblpv_IMG_6677.JPG",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/9ibncuuq_IMG_0586.JPG",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/v117lknh_IMG_6606.JPG",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/3sdl252v_Punjabi%20Audition.png",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/laes62tb_IMG_6689.JPG",
    "/images/frames_A45B.jpg",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/nfu5yl6f_IMG_8910.JPG",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/wuxz50ih_Haryanvi.jpg",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/pl1djeeb_IMG_6597.JPG",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/6zu8lf8s_IMG_3353.jpg",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/56cgl966_IMG_6663.JPG",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/l5lpi9fa_IMG-20260323-WA0006.jpg",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/3y2oqr4r_IMG_6692.JPG",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/3ddv04ld_IMG_5158.JPG",
    "/images/portfolio/75794a38e7714deeacdb1a7985848721.jpg",
    "/images/portfolio/55da30a949874e66a93850d33ecb4149.jpg",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/mm5tobda_exported_832DF483-D8F1-4DB0-BAA2-50C7C5829608.JPG",
    "/images/frames_E4E0.jpg",
    "https://customer-assets.emergentagent.com/job_029f3d36-c1f5-45c1-8b2c-87cb867c32a3/artifacts/gwadvazn_IMG_6817.JPG"
  ]
};
